import {
    Trigger,
    Content,
    Arrow,
    Separator,
    SubContent
} from '@radix-ui/react-dropdown-menu';
import styled, { css } from 'styled-components';
import { Z_INDEX } from '../../styles/variables';
import { vars } from '../../theme';
import spacing from '../../styles/spacing';

const SEPARATOR_COLOR = vars.colors.stroke.secondary;
const FOCUS_COLOR = vars.colors.stroke.keyboardFocus;

// shared with HBMenuSubMenu
export const baseTriggerStyles = css`
    // override button styles
    border: 0;
    padding: 0;
    background: none;
    &:hover,
    &:focus {
        background: none;
    }

    // &:focus-visible {
    //     outline: none !important;
    // }

    &[data-prevent-focus-visible] {
        // Remove default outline from wrapper
        outline: none;
        // Apply focus state to child instead of wrapper
        // This allows the focus ring to follow the child's shape (e.g., circular avatars)
        &:focus-visible > *,
        &[data-focus-visible] > * {
            outline: 2px solid ${FOCUS_COLOR};
            outline-offset: 0;
        }
    }

    &[disabled] {
        cursor: not-allowed;
    }
`;

export const baseContentStyles = css`
    border-radius: ${vars.radius.md};
    box-shadow: ${vars.shadow['40']};
    background: ${vars.colors.surface.container};
    padding: var(--hb-menu-content-padding, ${spacing[8]} 0);
    font-family: ${vars.fonts.body};
`;

export const StyledTrigger = styled(Trigger)<{ $resetStyles?: boolean }>`
    ${({ $resetStyles }) => $resetStyles && baseTriggerStyles}
`;

export const StyledContent = styled(Content)<{
    $withArrow: boolean;
    $maxWidth: string;
    $minWidth: string;
    $width?: string;
    $maxHeight: string;
}>`
    ${baseContentStyles}
    ${props => !props.$withArrow && `margin-top: 4px`};
    ${({ $width }) => $width && `width: ${$width};`}
    max-width: ${({ $maxWidth }) => $maxWidth};
    min-width: ${({ $minWidth }) => $minWidth};
    max-height: ${({ $maxHeight }) => $maxHeight};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 50px;
    z-index: ${Z_INDEX.MENU}; // needs to be higher than navbar

    // when using 'hideWhenDetached' prop radix will set opacity to 0, but the content is still clickable.
    // This hides the menu content when it's detached
    &[style*='opacity: 0'],
    &[style*='opacity:0'] {
        display: none;
    }
`;

// TODO: arrow box shadow?
export const StyledArrow = styled(Arrow).attrs({
    width: 16,
    height: 8,
    fill: vars.colors.surface.container
})``;

export const StyledDivider = styled(Separator)<{ $margin?: string }>`
    ${({ $margin }) => $margin && `margin: ${$margin};`}
    height: 0;
    border-top: 1px solid ${SEPARATOR_COLOR};
`;

export const StyledSubContent = styled(SubContent)<{ $maxHeight?: string }>`
    border-radius: ${vars.radius.md};
    box-shadow: ${vars.shadow['40']};
    background: ${vars.colors.surface.container};
    padding: 8px 0;
    max-height: ${props => props.$maxHeight || 'unset'};
    overflow-y: auto;
    margin-left: 4px;
`;

export const StyledSectionTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${vars.colors.text.tertiary};
`;

export const StyledIcon = styled.span`
    display: flex;
    color: inherit;

    &[data-selected] {
        height: 16px;
        color: ${vars.colors.text.primary};
    }
    &:not([data-set-default-fill-color]) svg * {
        fill: currentColor;
    }

    > i {
        display: flex;
    }
`;
